import { SeriesOption } from 'components/DailyStatsChartCard';
import { ParsedPlatformBreakoutData } from '../types';

export const CHART_STATS_SELECTOR_OPTIONS: SeriesOption<ParsedPlatformBreakoutData>[] =
  [
    {
      value: 'load',
      label: 'Widget Load',
    },
    {
      value: 'view',
      label: 'Widget View',
    },
    {
      value: 'play',
      label: 'Preview Play',
    },
    {
      value: 'clickthrough',
      label: 'Link Click',
    },
    {
      value: 'engage',
      label: 'Total plays',
    },
    {
      isPercentage: true,
      value: 'ctr',
      label: 'Viewable Engagement CTR',
    },
  ];
